import { createStore, applyMiddleware, compose } from 'redux'
import { persistStore } from 'redux-persist'
import createSagaMiddleware from 'redux-saga'
import rootReducer from './reducers'
import { requestsMiddleware } from './requests'
import { composeWithDevTools } from 'redux-devtools-extension'
import IndexSaga from './sagas'
import reducer from './misc/reducer'
// eslint-disable-next-line
import logger from 'redux-logger'

const sagaMiddleware = createSagaMiddleware()

let middleware

if (process.env.JEST_WORKER_ID) {
  middleware = compose(applyMiddleware(sagaMiddleware))
} else {
  middleware = compose(
    applyMiddleware(sagaMiddleware),
    applyMiddleware(...requestsMiddleware),
    //applyMiddleware(logger),
  )
}
//rootReducer(action.type === 'SIGN_OUT' ? undefined : state, action);
// @ts-ignore
export const store = createStore(rootReducer, composeWithDevTools(middleware))
sagaMiddleware.run(IndexSaga)
export const persistor = persistStore(store)
